<template>
  <div class="dashboard-driver-consumption-chart">
    <div class="chart-header">
      <div>
        <h3 class="chart-title">{{ $t('org-dashboard.driver-consumption-timeline') }}</h3>
      </div>
      <div class="chart-toggle-wrap">
        <v-btn-toggle v-model="metric" mandatory dense class="chart-toggle">
          <v-btn x-small value="kwh">kWh</v-btn>
          <v-btn x-small value="cost">€ HT</v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <div v-if="!hasData" class="no-data-placeholder">
      <v-icon color="#d1d5db">mdi-chart-areaspline</v-icon>
      <span>{{ $t('org-dashboard.no-data') }}</span>
    </div>
    <highcharts v-else :options="chartOptions" ref="chart" />
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'

export default {
  name: 'DashboardDriverConsumptionChart',
  components: {
    highcharts: Chart,
  },
  props: {
    data: { type: Array, default: () => [] },
    interval: { type: String, default: 'day' },
  },

  data() {
    return {
      metric: 'kwh',
    }
  },

  computed: {
    hasData() {
      return this.data && this.data.length > 0
    },

    chartOptions() {
      if (!this.hasData) return null

      const isKwh = this.metric === 'kwh'
      const color = isKwh ? '#3B82F6' : '#F59E0B'
      const unit = isKwh ? 'kWh' : '€'

      const seriesData = this.data.map(d => [
        new Date(d.date).getTime(),
        isKwh ? d.kwh : d.cost,
      ])

      return {
        chart: {
          type: 'areaspline',
          height: 300,
          backgroundColor: 'transparent',
          style: { fontFamily: 'inherit' },
          spacingTop: 10,
        },
        title: { text: null },
        credits: { enabled: false },
        legend: { enabled: false },
        xAxis: {
          type: 'datetime',
          labels: { style: { fontSize: '10px', color: '#9ca3af' } },
          gridLineWidth: 0,
          lineColor: '#e5e7eb',
          tickColor: '#e5e7eb',
        },
        yAxis: {
          title: { text: unit, style: { color: '#6b7280', fontSize: '11px' } },
          labels: { style: { color: '#6b7280', fontSize: '10px' } },
          gridLineColor: '#f1f5f9',
          min: 0,
        },
        tooltip: {
          shared: true,
          headerFormat: '<span style="font-size:10px">{point.key}</span><br/>',
          pointFormat: `<b>{point.y:.1f}</b> ${unit}`,
          xDateFormat: this.interval === 'month' ? '%B %Y' : '%e %b %Y',
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.15,
            lineWidth: 2,
            marker: { radius: 3, symbol: 'circle' },
          },
        },
        series: [{
          name: unit,
          data: seriesData,
          color,
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, color + '33'],
              [1, color + '05'],
            ],
          },
        }],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-driver-consumption-chart {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.chart-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.chart-toggle {
  border-radius: 6px !important;
  overflow: hidden;

  .v-btn {
    font-size: 11px !important;
    font-weight: 600 !important;
    letter-spacing: 0.3px;
    text-transform: none !important;
    min-width: 50px !important;
  }
}

.no-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
</style>